module.exports = __webpack_public_path__ + "static/media/writing.060c3525.png";